<template>
	<module-field :bind="$props">
		<div class="input-box">
			<date-picker v-model="inputVal" :placeholder="field.placeholder || 'Select Date'" class="theme-brand" format="yyyy-MM-dd"></date-picker>
		</div>
	</module-field>
</template>

<script>

import CrudField from '@/mixins/CrudField';
import moment from 'moment';

export default {
	mixins: [ CrudField ],

	data() {
		// return { inputVal: this.value[ this.field.slug ] };
		return {
			inputVal: this.value[ this.field.slug ]
				? moment(this.value[ this.field.slug ]).toDate()
				: null
		};
	},

	watch: {

		inputVal(newValue) {
			const date = moment(newValue, 'MM/DD/YYYY');
			this.$set(this.value, this.field.slug, date);
		},

	},

};
</script>

<style>
	.theme-brand .vdatetime-popup__header,
	.theme-brand .vdatetime-calendar__month__day--selected > span > span,
	.theme-brand .vdatetime-calendar__month__day--selected:hover > span > span {
		background: var(--brand-color);
	}

	.theme-brand .vdatetime-year-picker__item--selected,
	.theme-brand .vdatetime-time-picker__item--selected,
	.theme-brand .vdatetime-popup__actions__button {
		color: var(--brand-color);
	}
</style>
